"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitTypesDto = void 0;
exports.unitTypesDto = [
    "studio",
    "one-bedroom",
    "two-bedrooms",
    "three-bedrooms",
    "four-bedrooms",
    "five-bedrooms",
    "six-bedrooms",
];
console.log("UNIT TYPES?", exports.unitTypesDto);
